import { matchPath, useHistory, useParams } from 'react-router-dom';

import Skeleton from '@/components/common/Skeleton/Skeleton';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

interface IDetailsBreadcrumbProps {
  defaultText: string;
  routes: string[]
}

export default function DetailsPageBreadcrumb({ defaultText, routes }: IDetailsBreadcrumbProps) {
  const history = useHistory();
  const { contractId } = useParams<{ contractId: UUID }>();
  const { contract, isContractLoading, errorLoadingContract } = useGetContractDetails(contractId);
  const contractDetails = 'Contract:';

  const onClick = (event: any) => {
    event.preventDefault();
    const path = new URL(window.location.href).pathname;

    const isContractPage = matchPath(path, {
      path: routes,
      exact: true,
    });

    if (isContractPage) {
      window.location.reload();
    }
    else {

      const pathSegments = window.location.pathname.split('/').filter(x => x != '');
      let pathSegment = 'contracts-bc';
      if (pathSegments.length > 0) {
        const index = pathSegments.indexOf(contractId);
        if (index > 0) {
          pathSegment = pathSegments.slice(0, index).join('/');
        }
      }

      const link = getParameterizedLink(`/${pathSegment}/${contractId}`);
      history.push(link);
    }
  };

  if (isContractLoading) {
    return <Skeleton width={100} />;
  }

  if (errorLoadingContract || !contract) {
    return <>{defaultText}</>;
  }

  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {`${contractDetails} ${contract.contractNumber}`}
    </a>
  );
}
